import { Navigate, useLocation } from "react-router-dom";

/** Maps legacy /civix-accounts hashes to the unified /features anchors. */
export default function CivixAccountsRedirect() {
  const { hash } = useLocation();
  const target =
    hash === "#verification" ? "#verification" : "#plans";
  return <Navigate to={`/features${target}`} replace />;
}
